/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AgencyState { 
    id?: AgencyState.IdEnum;
    initialAgencySetupRole?: boolean;
    receiveRerralsRole?: boolean;
    state?: string;
    supportsExpirationRole?: boolean;
    userInstructions?: string;
    version?: number;
}
export namespace AgencyState {
    export const IdEnum = {
        NewAgency: 'NEW_AGENCY',
        Inactive: 'INACTIVE',
        Renewal: 'RENEWAL',
        RenewalExpired: 'RENEWAL_EXPIRED',
        Approved: 'APPROVED',
        Denied: 'DENIED'
    } as const;
    export type IdEnum = typeof IdEnum[keyof typeof IdEnum];
}


